import { createDynamicThunk } from ".";

export const getPendingRequestListThunk = createDynamicThunk({
  typePrefix: "pendingRequests/getPendingRequestListThunk",
  useHandleSearch: true,
  transformResponse: (result) => {
    // Return only the list the slice should store
    return {
      list: result.data,            // this maps to slice.list
      pagination: result.pagination,
      totalCount: result.totalCount
    };
  }
});

export const getPendingRequestDetailThunk = createDynamicThunk({
  typePrefix: "pendingRequests/getPendingRequestDetailThunk",
  endpoint: "/pending-requests",
  method: "GET",
  refreshList: false,
});

export const updatePendingRequestsThunk = createDynamicThunk({
  typePrefix: "pendingRequests/updatePendingRequestsThunk",
  endpoint: "/pending-requests",
  method: "PUT",
  refreshList: true,  
  listThunk: getPendingRequestListThunk,
});

export const addPendingRequestThunk = createDynamicThunk({
  typePrefix: "pendingRequests/addPendingRequestThunk",
  endpoint: "/pendingRequests",
  method: "POST",
  refreshList: true,
  listThunk: getPendingRequestListThunk,
});

export const deletePendingRequestThunk = createDynamicThunk({
  typePrefix: "/deletePendingRequestThunk",
  endpoint: "/softDeleteMul",
  method: "POST",
  refreshList: true,
  listThunk: getPendingRequestListThunk,
});
